<app-confirmed-membership *transloco="let t">
  <app-main-header header>{{ t('continue-in-the-business') }}</app-main-header>
  <app-header isBig title>{{ t('you-will-continue-same-business', { organization: currentBusiness.businessName })}}</app-header>
  <app-rounded-image image [src]="currentBusiness.imgSource"></app-rounded-image>
  <div buttonSection>
    <app-primary-button id="lnr-refused-representative-membership" [routerLink]="'/'+RoutesKeys.HOME">
      {{ t('go-home') }}
    </app-primary-button>
  </div>
</app-confirmed-membership>
